import gql from "graphql-tag";

export default gql`
  fragment LinkFields on Link {
    url
    external
  }
`;
